export const colors = {
    main: '#F98226',//naranja
    blueText: '#64b2ff',//azul
    dark: '#161c24',
    
}